/**
 * Un campo de un informe: rótulo arriba, valor abajo.
 *
 * El valor ausente se dibuja como `—` y NO se omite la fila. Vale para las dos
 * pantallas que lo usan y por el mismo motivo: en el documento que se firma,
 * "no se completó" es información —esconderlo haría que el cliente no note lo
 * que falta— y en la ficha de visado es exactamente lo que el revisor tiene
 * que ver antes de aprobar.
 *
 * Vive como componente propio porque estaba duplicado entre el documento de
 * cotización y la ficha de visado: dos copias de una decisión que es UNA.
 */
export function DatoDelInforme({
  etiqueta,
  valor,
  children,
}: {
  etiqueta: string;
  valor?: string | null;
  children?: React.ReactNode;
}) {
  return (
    <div>
      <p className="text-label text-ink-muted uppercase">{etiqueta}</p>
      <div className="mt-1">
        {children ?? <p className="text-ink-body text-body">{valor?.trim() || "—"}</p>}
      </div>
    </div>
  );
}
